function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.66675 3.50002C1.66675 2.21136 2.71142 1.16669 4.00008 1.16669H6.33341C7.62208 1.16669 8.66675 2.21136 8.66675 3.50002V5.83335C8.66675 7.12202 7.62208 8.16669 6.33341 8.16669H4.00008C2.71142 8.16669 1.66675 7.12202 1.66675 5.83335V3.50002Z",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3334 3.50002C13.3334 2.21136 14.3781 1.16669 15.6667 1.16669H18.0001C19.2887 1.16669 20.3334 2.21136 20.3334 3.50002V5.83335C20.3334 7.12202 19.2887 8.16669 18.0001 8.16669H15.6667C14.3781 8.16669 13.3334 7.12202 13.3334 5.83335V3.50002Z",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M1.66675 15.1667C1.66675 13.878 2.71142 12.8334 4.00008 12.8334H6.33341C7.62208 12.8334 8.66675 13.878 8.66675 15.1667V17.5C8.66675 18.7887 7.62208 19.8334 6.33341 19.8334H4.00008C2.71142 19.8334 1.66675 18.7887 1.66675 17.5V15.1667Z",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3334 15.1667C13.3334 13.878 14.3781 12.8334 15.6667 12.8334H18.0001C19.2887 12.8334 20.3334 13.878 20.3334 15.1667V17.5C20.3334 18.7887 19.2887 19.8334 18.0001 19.8334H15.6667C14.3781 19.8334 13.3334 18.7887 13.3334 17.5V15.1667Z",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.cd9d3018.svg";
export { ForwardRef as ReactComponent };